<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="620"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div
              class="pa-4 popup-header">
              <div
                class="title font-weight-bold black--text text-center mb-1">
                Skor Presensi
              </div>

              <div
                class="body-1 text-center">
                Tentukan nilai berdasarkan informasi dibawah ini:
              </div>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div
                    class="body-2 mb-8">
                    <ul
                      style="position: relative; left: -10px;">
                      <li
                        v-for="(item, index) in info"
                        :key="index"
                        :class="index < info.length - 1 ? 'mb-2' : ''"
                        v-html="item">  
                      </li>
                    </ul>
                  </div>
                  
                  <ValidationProvider 
                    name="Persentase Kehadiran" 
                    rules="required|max_100:100"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      
                      Persentase Kehadiran
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      hide-details
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      placeholder="Contoh. 70"

                      suffix="%"

                      @focus="$event.target.select()"

                      v-model="form.label_score"
                      :success="form.label_score !== '' && valid"
                      :error-messages="errors"
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.label_score !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.reset"
          @keydown.esc="dialog.reset = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right font-weight-bold popup-header">
              Reset Nilai

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin mereset nilai data <b class="font-weight-bold black--text">Tugas Utama Skor Presensi</b> ini?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="resetes()"
                :loading="process.reset"
                :disabled="process.reset"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Reset
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
                :disabled="process.reset"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-card 
            flat
            class="mb-6"
            style="border-radius: 10px; border: 2px dashed #E7E7E7;">
            <v-card-text
              :class="process.load ? 'pa-4 py-0' : 'pa-3 px-0 pb-0'"
              :style="list.length > 0 ? 'height: calc(100vh - 440px);' : 'height: calc(100vh - 438px);'"
              style="overflow-y: auto;">
              <v-row v-if="process.load">
                <v-col
                  v-for="i in 12"
                  :key="i"
                  cols="12"
                  md="4">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="image">
                  </v-skeleton-loader>
                </v-col>
              </v-row>

              <div v-if="!process.load">
                <Calendar
                  language="id"
                  :display-header="false"
                  :week-start="1"

                  :year="new Date(summary.start_date).getFullYear()"

                  :data-source="list"
                  
                  @click-day="showDayEvents">
                </Calendar>
                
                <v-menu
                  v-model="selected.open"
                  :close-on-content-click="false"
                  :activator="selected.element"
                  offset-y
                  bottom
                  transition="slide-y-transition">
                  <v-card v-if="Object.keys(selected.event).length > 0"
                    width="400"
                    flat>
                    <v-toolbar
                      dark
                      elevation="0"
                      :color="selected.event.color">
                      <v-toolbar-title 
                        class="body-1 font-weight-bold text-capitalize">
                        {{ selected.event.user_name }}
                      </v-toolbar-title>

                      <v-spacer/>

                      <v-btn 
                        icon
                        @click="selected.open = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>

                    <v-card-text>
                      <div
                        class="body-2 text-capitalize mb-1 d-flex align-center">
                        <v-icon small>mdi-calendar-month-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ selected.event.status === 'leave' ? 'Meninggalkan Jam Kerja': selected.event.status  }}
                        </span>
                      </div>

                      <div
                        class="title font-weight-bold black--text">
                        {{ selected.event.date | date }}
                      </div>

                      <v-divider
                        class="mt-4 mb-6"
                        style="border-top: 3px solid #f2f2f2; border-radius: 50px;" />

                      <v-row v-if="selected.event.status !== 'ijin' && selected.event.status !== 'cuti'"
                        class="mb-6">
                        <v-col
                          cols="6"
                          class="py-0">
                          <div
                            class="caption">
                            {{ selected.event.status === 'hadir' ? 'Datang:' : 'Jam Mulai' }}
                          </div>

                          <div
                            class="green--text">
                            <span v-if="selected.event.status === 'hadir'">
                              {{ selected.event.start_datetime | datetime }}
                            </span>

                            <span v-if="selected.event.status === 'leave'">
                              {{ selected.event.start_datetime | time }}
                            </span>
                          </div>
                        </v-col>

                        <v-col
                          cols="6"
                          class="py-0">
                          <div
                            class="caption">
                            {{ selected.event.status === 'hadir' ? 'Pulang:' : 'Jam Selesai' }}
                          </div>

                          <div>
                            <span v-if="selected.event.status === 'hadir'">
                              <span v-if="selected.event.end_datetime !== ''"
                                class="red--text">
                                {{ selected.event.end_datetime | datetime }}
                              </span>

                              <span v-else>
                                -
                              </span>
                            </span>

                            <span v-if="selected.event.status === 'leave'"
                              class="red--text">
                              {{ selected.event.end_datetime | time }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>

                      <div v-if="selected.event.status !== 'hadir'"
                        class="body-2 mb-4">
                        <div
                          class="black--text font-weight-bold mb-2">
                          Alasan:
                        </div>

                        <div>
                          {{ selected.event.leave_reason !== '' ? selected.event.leave_reason : '-' }}
                        </div>
                      </div>

                      <div v-if="selected.event.status === 'hadir'"
                        class="body-2 font-weight-bold black--text mb-4">
                        Lokasi:
                      </div>

                      <div v-if="selected.event.status === 'hadir'"
                        class="mb-6">
                        <gmap-map
                          ref="gmap"
                          :center="center"
                          :zoom="15"
                          :scrollwheel="false"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
                          style="width:100%; height: 30vh;">
                          <gmap-marker
                            :position="currentPosition.latlng"
                            :icon="currentPosition.icon">
                          </gmap-marker>
                        </gmap-map>
                      </div>

                      <div v-if="selected.event.status === 'hadir'"
                        class="body-2 font-weight-bold black--text mb-2">
                        Jarak:
                      </div>

                      <v-row v-if="selected.event.status === 'hadir'">
                        <v-col
                          cols="6"
                          class="pt-0">
                          <div
                            class="caption">
                            Datang:
                          </div>

                          <div>
                            <span v-if="selected.event.end_range !== ''">
                              <strong>{{ selected.event.end_range }}</strong> Meter
                            </span>

                            <span v-else>
                              -
                            </span>
                          </div>
                        </v-col>

                        <v-col
                          cols="6"
                          class="pt-0">
                          <div
                            class="caption">
                            Pulang:
                          </div>

                          <div>
                            <span v-if="selected.event.end_range !== ''">
                              <strong>{{ selected.event.end_range }}</strong> Meter
                            </span>

                            <span v-else>
                              -
                            </span>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-if="selected.event.status === 'hadir'">
                        <v-col
                          cols="6"
                          class="py-0">
                          <div
                            class="caption mb-1">
                            Gambar Datang:
                          </div>

                          <v-img v-if="selected.event.start_image_url !== ''"
                            contain
                            alt="amanata" 
                            width="100%"
                            height="auto"
                            :src="selected.event.start_image_url"
                            class="ma-auto border-radius">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>

                          <div v-else>
                            <strong>-</strong>
                          </div>
                        </v-col>

                        <v-col
                          cols="6"
                          class="py-0">
                          <div
                            class="caption mb-1">
                            Gambar Pulang:
                          </div>

                          <v-img v-if="selected.event.end_image_url !== ''"
                            contain
                            alt="amanata" 
                            width="100%"
                            height="auto"
                            :src="selected.event.end_image_url"
                            class="ma-auto border-radius">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>

                          <div v-else>
                            <strong>-</strong>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </v-card-text>
          </v-card>

          <v-card 
            flat
            :color="set_color_rgb_down"
            style="border-radius: 10px; border: 1px solid #E7E7E7;">
            <v-row>
              <v-col
                cols="12"
                :md="detail_skor.id !== '' ? 9 : 10"
                class="py-0 pr-0">
                <v-card
                  @click="dialog.form = true; reset();"
                  flat
                  color="transparent"
                  style="border-radius: 10px 0px 0px 10px;">
                  <v-card-text
                    class="font-weight-bold black--text">
                    Skor Presensi{{ detail_skor.indicator_label_score < 1 ? ', klik disini' : ` adalah ${detail_skor.indicator_score}` }}
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="2"
                class="py-0"
                :class="detail_skor.id !== '' ? 'px-0' : 'pl-0'">
                <v-card
                  flat
                  min-height="56"
                  :style="detail_skor.id !== '' ? 'border-radius: 0px;' : 'border-radius: 0px 10px 10px 0px;'">
                  <v-card-text
                    class="font-weight-bold text-center">
                    {{ detail_skor.indicator_label_score > 0 ? detail_skor.indicator_label_score : 0 }} %
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col v-if="detail_skor.id !== ''"
                cols="12"
                md="1"
                class="py-0 pl-0">
                <v-card
                  @click="toReset()"

                  flat
                  min-height="56"
                  color="orange"
                  style="border-radius: 0px 10px 10px 0px;">
                  <v-card-text
                    class="text-center">
                    <v-icon color="white">mdi-reload-alert</v-icon>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  import Calendar from 'v-year-calendar'
  import 'v-year-calendar/locales/v-year-calendar.id'
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      },
      summary: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          
          form: false,
          reset: false
        },

        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],

        center: {
          lat: null,
          lng: null
        },

        currentPosition: {},

        selected: {
          item: {},
          reset: {},

          open: false,
          element: null,
          event: {}
        },

        info: [
          'Kurang dari 50% (Skor 20)',
          '50% sampai dengan / kurang dari 60% (Skor 40)',
          '60% sampai dengan / kurang dari 70% (Skor 60)',
          '70% sampai dengan / kurang dari 80% (Skor 80)',
          'Lebih dari 80% (Skor 100)'
        ],

        detail_skor: {
          id: '',
          indicator_summary_id: '',
          user_id: '',
          indicator_label_score: 0,
          indicator_score: 0
        },

        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          summary_id: '',
          user_id: '',
          label_score: 0,
          score: 0
        },

        process: {
          load: false,

          form: false,
          reset: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Calendar
    },
    watch: {
      'form.label_score': function(val) {
        if (val === '' || val === 0) {
          this.form.score = ''
        } else {
          if (val < 50) {
            this.form.score = 20
          }
  
          if (val >= 50 && val < 60) {
            this.form.score = 40
          }

          if (val >= 60 && val < 70) {
            this.form.score = 60
          }

          if (val >= 70 && val < 80) {
            this.form.score = 80
          }

          if (val >= 80) {
            this.form.score = 100
          }
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchData()
        this.fetchSkor()
      },

      async fetchData () {
        this.process.load = true

        let params = {
          user_id: this.detail.id,

          start_date: this.summary.start_date,
          end_date: this.summary.end_date
        }

        await get(`kpi_v2/presensi/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            let data = res.results.data

            data.map((obj) => {
              this.list.push({
                name: obj.status === 'hadir' ? 'Hadir' : obj.status === 'ijin' ? 'Izin' : obj.status === 'leave' ? 'Meninggalkan Jam Kerja' : 'Cuti',
                date: obj.date,
                start: obj.start_datetime !== '' ? obj.start_datetime : obj.date,
                end: obj.end_datetime !== '' ? obj.end_datetime : obj.date,
                
                user_id: obj.user_id,
                user_name: obj.user_name,
                status: obj.status,
                leave_reason: obj.leave_reason,

                startDate: new Date(obj.start_datetime),
                endDate: new Date(obj.end_datetime),

                start_datetime: obj.start_datetime,
                end_datetime: obj.end_datetime,
                
                start_range: obj.start_range,
                end_range: obj.end_range,

                unit_id: obj.unit_id,

                start_latitude: obj.start_latitude,
                end_latitude: obj.end_latitude,

                start_longitude: obj.start_longitude,
                end_longitude: obj.end_longitude,

                start_image_url: obj.start_image_url,
                end_image_url: obj.end_image_url,

                color: obj.status === 'hadir' ? 'green' : obj.status === 'ijin' ? 'blue' : obj.status === 'leave' ? 'orange' : 'red'
              })
            })

            this.pagination = res.results.pagination
          }
        })
      },

      async fetchSkor () {
        let params = {
          user_id: this.detail.id,

          indicator_summary_id: this.summary.id,

          start_date: this.summary.start_date,
          end_date: this.summary.end_date
        }

        await get('kpi_v2/presensi/data', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_skor = res.results.data.length > 0 ? res.results.data[0] : {
              id: '',
              indicator_summary_id: this.summary.id,
              user_id: this.detail.id,
              indicator_label_score: 0,
              indicator_score: 0
            }
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        let params = {
          user_id: this.detail.id,

          start_date: this.summary.start_date,
          end_date: this.summary.end_date
        }

        get('kpi_v2/presensi/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form = {
              id: this.detail_skor.id,
              summary_id: this.detail_skor.indicator_summary_id,
              user_id: this.detail_skor.user_id,
              label_score: this.detail_skor.indicator_label_score < 1 ? res.results.label : this.detail_skor.indicator_label_score,
              score: this.detail_skor.indicator_score < 1 ? res.results.score : this.detail_skor.indicator_score
            }
          }
        })

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.detail_skor.indicator_label_score < 1 ? 'kpi_v2/presensi/add_score' : 'kpi_v2/presensi/update_score'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchSkor()

              this.$emit('refresh', true)
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toReset () {
        this.selected.reset = this.detail_skor

        this.dialog.reset = true
      },

      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post(`kpi_v2/presensi/reset_score`, {
          data: {
            id: this.selected.reset.id
          }
        }).then(response => {
          let res = response.data

          this.process.reset = false

          if (res.status === 200) {

            this.dialog.reset = false

            this.selected.reset = {}
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchSkor()

            this.$emit('refresh', true)
          } else {
            this.message.error = res.message
          }
        })
      },

      showDayEvents(e) {
        if (e.events.length > 0) {
          const open = () => {
            this.selected.event = e.events[0]
    
            this.selected.element = e.element
    
            this.$gmapApiPromiseLazy().then(() => {
              this.center = {
                lat: parseFloat(this.selected.event.start_latitude),
                lng: parseFloat(this.selected.event.start_longitude)
              }
    
              this.currentPosition = {
                latlng: {
                  lat: parseFloat(this.selected.event.start_latitude),
                  lng: parseFloat(this.selected.event.start_longitude)
                },
                icon: {
                  url: require('@/assets/image/location_pin.png'),
                  scaledSize: new google.maps.Size(50, 50),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(25, 50)
                }
              }
            })
    
            setTimeout(() => {
              this.selected.open = true
            }, 10)
          }

          if (this.selected.open) {
            this.selected.open = false

            setTimeout(open, 10)
          } else {
            open()
          }
        }
      }
    }
  }
</script>

<style lang="css" scoped>
  .calendar {
    overflow-x: initial;
    border-radius: 10px;
  }

  .calendar >>> .months-container .month-container {
    height: initial;
    margin-bottom: 24px;
  }

  .calendar >>> table.month {
    background-color: white;
    border: 1px solid rgb(224, 224, 224);
    border-radius: 10px;

    height: 100%;
    min-width: 300px;
    min-height: 310px;
  }

  .calendar >>> table.month th.month-title {
    background-color: rgb(224, 224, 224);
    padding: 8px;
    font-size: 14px;
    font-weight: 700;

    border-radius: 10px 10px 0 0;
  }

  .calendar >>> table.month th.day-header {
    padding: 8px;
    color: rgb(124, 124, 124);
    font-size: 12px;
    font-weight: 500;
  }

  .calendar >>> table.month td.day {
    height: 16px;
  }

  .calendar >>> table.month td.day .day-content {
    padding: 8px;
    border-radius: 8px;
  }
</style>